module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318735.f2c9eff3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318735.pdf
// module id = 838
// module chunks = 0